/*
 This file is part of GNU Taler
 (C) 2022-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */
import {
  RouteDefinition,
  useTranslationContext,
} from "@gnu-taler/web-util/browser";
import { TranslatedString } from "@gnu-taler/taler-util";
import { Fragment, VNode, h } from "preact";
import { Cashouts } from "../../components/Cashouts/index.js";

interface Props {
  account: string;
  routeCashoutDetails: RouteDefinition<{ cid: string }>;
  routeBack: RouteDefinition;
  backLabel: TranslatedString;
}

export function CashoutListForAccount({
  account,
  routeCashoutDetails,
  routeBack,
  backLabel,
}: Props): VNode {
  const { i18n } = useTranslationContext();

  return (
    <Fragment>
      <a
        href={routeBack.url({})}
        class="inline-flex items-center text-sm font-semibold text-brand hover:underline"
      >
        <span class="mr-1" aria-hidden="true">
          ←
        </span>
        {backLabel}
      </a>
      <div class="mt-6">
        <h1 class="text-2xl font-semibold text-brand">
          <i18n.Translate>Cashout history</i18n.Translate>
        </h1>
        <p class="mt-2 text-sm text-gray-600">
          <i18n.Translate>
            Review previous transfers to your configured cashout account.
          </i18n.Translate>
        </p>
        <Cashouts account={account} routeCashoutDetails={routeCashoutDetails} />
      </div>
    </Fragment>
  );
}
